import React from "react";
import PropTypes from 'prop-types';
import {getStyle} from "../../../services/Style";
import {MDBProgress} from "mdbreact";

export default class Skills extends React.PureComponent
{
    static propTypes = {
        skills: PropTypes.oneOf([PropTypes.array, PropTypes.object]).isRequired,
        language: PropTypes.string.isRequired,
		positionId: PropTypes.number,
		customerName: PropTypes.string.isRequired
    };

    renderSkill = (skill, index, color) => {
        let name = skill.name;
        if(skill.cSkill) {
            name = skill.cSkill.name;
            if (skill.cSkill.locale) {
                let locale = skill.cSkill.locale.find((loc) => loc.lang === this.props.language);
                name = locale ? locale.name : name;
            }
        }
        return (
            <div key={index}>
                <br />
                <div className={'row'} style={{'padding-left': '20px','padding-right': '30px', 'margin-bottom':'-28px'}} >
                    <div className={'col-11 whiteFont'}>{name}</div>
                    <div className={'col-1 whiteFont'}>{skill.level * 20}%</div>
                </div>
                <MDBProgress value={skill.level * 20} height="30px" color={color} barClassName={'skillBar'} >
                </MDBProgress>
            </div>
        );
    };

    render() {
        if (!this.props.skills) {
            return null;
        }
        let skills = Array.isArray(this.props.skills) ? this.props.skills : Object.values(this.props.skills);
        if (skills.length === 0) {
            return null;
        }
        let color = getStyle(this.props.positionId, 'progress-bar', this.props.customerName)['background-color'];
        return (
            <div className="skills details-section">
                <h4 style={{'padding-bottom': '0px'}}>
                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 far fa-address-card "}> </i>
                    {window.Translator.getSlug('Skills', this.props.language)}
                </h4>
                {skills.map((skill, index) => this.renderSkill(skill, index, color))}
            </div>
        );
    }
}
